import axios from 'axios'
import _difference from 'lodash/difference'
import _get from 'lodash/get'

import { getTaxConsultationTopicsByTaxConsultationId } from '../selectors/tax-consultation-topics'
import { handleRequestError } from './request'

export const REQUEST_TAX_CONSULTATION_TOPICS = 'REQUEST_TAX_CONSULTATION_TOPICS'
export const RECEIVE_TAX_CONSULTATION_TOPICS = 'RECEIVE_TAX_CONSULTATION_TOPICS'
export const REMOVE_TAX_CONSULTATION_TOPIC = 'REMOVE_TAX_CONSULTATION_TOPIC'

export const requestTaxConsultationTopics =
    ({ taxConsultationId }) =>
    (dispatch) => {
        dispatch({ type: REQUEST_TAX_CONSULTATION_TOPICS })

        return axios
            .get(`/taxconsultations/${taxConsultationId}/topics`, { headers: { 'Cache-Control': 'no-cache' } })
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultationTopics({ items: responseData, fetchSuccessful: true }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const saveTaxConsultationTopics =
    ({ taxConsultationId, topicTypes: newTopicTypes }) =>
    (dispatch, getState) => {
        const existingTopics = getTaxConsultationTopicsByTaxConsultationId(getState(), { taxConsultationId })
        const existingTopicTypes = existingTopics.map(({ topicType }) => topicType)

        // Find creatable types
        const creatableTopicTypes = newTopicTypes.filter((newTopicType) => !existingTopicTypes.includes(newTopicType))
        const creatableTopicsPromises = creatableTopicTypes.map((topicType) => {
            const creatableTopicData = { taxConsultationId, topicType }
            return dispatch(createTaxConsultationTopic(creatableTopicData))
        })

        // Find deletable ids
        const deletableTopicTypes = _difference(existingTopicTypes, newTopicTypes)
        const deletableTopicIds = existingTopics
            .filter((topic) => deletableTopicTypes.includes(topic.topicType))
            .map(({ id }) => id)
        const deletableTopicPromises = deletableTopicIds.map((id) => dispatch(deleteTaxConsultationTopic({ id })))

        return Promise.all([...creatableTopicsPromises, ...deletableTopicPromises])
    }

const createTaxConsultationTopic = (data) => (dispatch) =>
    axios
        .post(`/taxconsultationtopics`, data)
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveTaxConsultationTopics({ items: [responseData] }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })

const deleteTaxConsultationTopic =
    ({ id }) =>
    (dispatch) =>
        axios
            .delete(`/taxconsultationtopics/${id}`)
            .then(() => {
                dispatch(removeTaxConsultationTopic({ id }))
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })

export const receiveTaxConsultationTopics = (data) => ({ type: RECEIVE_TAX_CONSULTATION_TOPICS, data })

export const removeTaxConsultationTopic = ({ id }) => ({ type: REMOVE_TAX_CONSULTATION_TOPIC, data: { id } })
